/* eslint-disable no-console */
import { Injectable, inject } from '@angular/core';
import { AppData } from '@app/shared/models/appdata.model';
import { Environment } from '../models/environment.model';
import { AppInsightsService } from './application-insights.service';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private appData = inject(AppData);
  private appInsights = inject(AppInsightsService);

  error(message: string, ...args: unknown[]): void {
    if (this.appData.environment !== Environment.Production) {
      console.error(message, ...args);
    }

    const error = args[0];
    if (error instanceof Error) {
      this.appInsights.trackError(error);
    } else {
      this.appInsights.trackError(message, { details: JSON.stringify(args) });
    }
  }

  warn(message: string, ...args: unknown[]): void {
    if (this.appData.environment !== Environment.Production) {
      console.warn(message, ...args);
    }

    this.appInsights.trackWarning(message, { details: JSON.stringify(args) });
  }

  info(message: string, ...args: unknown[]): void {
    if (this.appData.environment !== Environment.Production) {
      console.info(message, ...args);
    }

    this.appInsights.trackEvent('Info', {
      message,
      details: JSON.stringify(args),
    });
  }
}
